// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"zT-z","inlineTitle":"AT-z","sponsoredAdsWrapper":"BT-z","marketplaceRecosWrapper":"CT-z"};